import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Form, Button, Spinner, Modal } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons'
import { useParams } from 'react-router-dom'
import { ReportListLink as ReportList } from '../components'
import apiServices from '../services/apiServices'

function Warn({ setting }) {
  const { size = 'md', show = false, handleClose } = setting

  return (
    <Modal
      style={{ zIndex: '1501' }}
      size={size}
      show={show !== false}
      onHide={() => handleClose(false)}
    >
      <Modal.Header
        className="AccFormModal justify-content-center text-center pt-4"
        closeButton
      >
        <Modal.Title>
          <h4>系統訊息</h4>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="d-flex AccformCard">
        <div className="assPermis w-100">
          <Form className="px-2 Form-card flex-grow-1">
            <Form.Group className="px-5 lh-md text-center text-dai">
              <FontAwesomeIcon
                icon={faCircleExclamation}
                style={{ height: '5rem' }}
                className="my-4"
              />
              <Form.Label className="w-100 fs-5 fw-bold text-center pb-4">
                確定要刪除嗎？
              </Form.Label>
            </Form.Group>
          </Form>
        </div>
      </Modal.Body>
      <Modal.Footer className="sendForm justify-content-center py-3">
        <Button variant="secondary" onClick={() => handleClose(false)}>
          取消
        </Button>
        <Button variant="dai" onClick={() => handleClose(show)}>
          確定
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

function AdManagerReportFormLink() {
  const [dimensions, setdimensions] = useState([])
  const getDimensions = async () => {
    const res = await apiServices.data({
      path: 'report/customdimensions',
      method: 'get',
    })
    const customFieldsRes = await apiServices.data({
      path: 'report/line-item-custom-fields',
      method: 'get',
    })
    console.log('customdimensions', res)
    console.log('customFieldsRes', customFieldsRes)
    setdimensions(res.concat(customFieldsRes))
  }
  useEffect(() => {
    getDimensions()
  }, [])
  console.log(dimensions)

  const [downloadUrl, setDownloadUrl] = useState(null)
  const [records, setRecords] = useState(null)
  const [names, setNames] = useState({})

  const params = useParams()
  const getLinkData = async () => {
    const { token } = params
    const res = await apiServices.data({
      path: `report/getLink`,
      method: 'post',
      data: {
        token,
      },
    })
    setRecords(res.records)
    setDownloadUrl(res.downloadUrl)
    setNames(res.names || {})
  }

  useEffect(() => {
    getLinkData()
  }, [])

  return (
    <div className="px-5">
      {!(downloadUrl && records) && (
        <div className="d-flex h-100 justify-content-center">
          <Spinner
            className="my-auto"
            animation="border"
            size="sm"
            style={{
              animation: 'spinner-border 1.5s linear infinite',
            }}
          />
          <h5 className="text-dai fs-4 my-auto ms-2">資料載入中...</h5>
        </div>
      )}
      {/* {downloadUrl && (
        <Alert variant="success" className="mt-3">
          <a href={downloadUrl} target="_blank" rel="noreferrer">
            點此下載報表
          </a>
        </Alert>
      )} */}
      {records && (
        <ReportList
          setting={{
            handleEditLink: async () => {},
            mockups: [],
            data: records,
            names,
            fieldLabelMap: {
              impression: '計算曝光數', // 曝光
              click: '計算點擊數', // 點擊
              revenue: '計算收益', // 收益
              click_rate: '計算點擊率', // 點擊率
              'Dimension.AD_UNIT_ID': '廣告單元 ID',
              'Dimension.AD_UNIT_NAME': '廣告單元名稱',
              'Dimension.LINE_ITEM_ID': '廣告項目 ID',
              'Dimension.LINE_ITEM_NAME': '委刊項', // 廣告項目名稱
              'Dimension.DATE': '日期',
              'Column.AD_SERVER_IMPRESSIONS': '廣告伺服器曝光', // 曝光次數
              'Column.AD_SERVER_CLICKS': '廣告伺服器點擊', // 點擊次數
              'Column.AD_SERVER_CTR': '廣告伺服器點擊率', // 點閱率
              'Column.AD_SERVER_REVENUE': '收益',
              'Column.AD_EXCHANGE_LINE_ITEM_LEVEL_IMPRESSIONS': 'AdX 曝光次數',
              'Column.AD_EXCHANGE_LINE_ITEM_LEVEL_CLICKS': 'AdX 點擊次數',
              'Column.AD_EXCHANGE_LINE_ITEM_LEVEL_REVENUE': 'AdX 收益',
              'Column.AD_EXCHANGE_TOTAL_REQUESTS': 'AdX 請求次數',
              ...dimensions.reduce((prev, cur) => {
                const isCustomTargetingKey = cur.name.includes(
                  'customTargetingKeys'
                )
                const isCustomField = cur.name.includes('customFields')

                if (isCustomTargetingKey) {
                  return {
                    ...prev,
                    [`Dimension.TOP_LEVEL_CUSTOM_TARGETING_KEY[${cur.id}]_VALUE`]:
                      cur.displayName,
                    [`Dimension.TOP_LEVEL_CUSTOM_TARGETING_KEY[${cur.id}]_ID`]: `${cur.displayName}ID`,
                  }
                }
                if (isCustomField) {
                  return {
                    ...prev,
                    [`CF[${cur.id}]_Value`]: cur.displayName,
                  }
                }
                return prev
              }, {}),
            },
          }}
        />
      )}
    </div>
  )
}

Warn.propTypes = {
  setting: PropTypes.shape().isRequired,
}

export default AdManagerReportFormLink
